type Sha = (...args: any[]) => string | PromiseLike<string>;

export abstract class CryptoHashService {
  abstract sha1: Sha;
  abstract sha256: Sha;
  abstract sha384: Sha;
  abstract sha512: Sha;
}
